import { Mic } from "lucide-react";
import CardContainer from "../Containers/CardContainer";
import Heading from "../Headers/Heading";
import SentenceCard from "../Cards/SentenceCard";
import BlockButton from "../Buttons/BlockButton";

const StatusCard = ({ dialogState, onStartListening, isListening }) => {
  return (
    <CardContainer className="p-6">
      <Heading>অনুশীলন</Heading>

      {/* Current Status */}
      <SentenceCard
        header="বর্তমান অবস্থা"
        sentence={dialogState}
        color="blue"
        cardClassName="mb-4"
      />

      {/* Voice Input Button */}
      <BlockButton
        onClick={onStartListening}
        disabled={isListening}
        backgroundColor={isListening ? "bg-red-100" : "bg-blue-600"}
        hoverBackgroundColor={isListening ? "bg-red-200" : "bg-blue-700"}
        textColor={isListening ? "text-red-700" : "text-white"}
        className={isListening ? "animate-pulse" : ""}
        icon={
          <Mic className={`h-6 w-6 ${isListening ? "animate-pulse" : ""}`} />
        }
        text={
          isListening ? "শুনছি..." : "এই বোতামে চাপ দিয়ে ইংরেজি শব্দটি বলুন"
        }
      />
    </CardContainer>
  );
};

export default StatusCard;
